import { createAction } from 'redux-actions';
import { getAuthUserCountry } from 'utils/getAuthUserCountry';
import { commonGet, axiosEvents } from './api';
import shareInFlight from './inFlight';

export const RESET_TYPES = {
  LIST: 'LIST',
  ITEM: 'ITEM',
};

export const createCommonListConstants = (listName = '') => {
  const listNameUpper = listName.toUpperCase();
  return {
    SET_LIST: `${listNameUpper}_SET_LIST`,
    SET_IS_PENDING: `${listNameUpper}_SET_IS_PENDING`,
    SET_COUNTRIES: `${listNameUpper}_SET_COUNTRIES`,
  };
};

export const createCommonItemConstants = (itemName = '') => {
  const itemNameUpper = itemName.toUpperCase();
  return {
    SET_ITEM: `${itemNameUpper}_SET_ITEM`,
    SET_IS_PENDING: `${itemNameUpper}_SET_IS_PENDING`,
  };
};

export const createCommonListReducer = (actionTypes = {}, transform) => {
  const defaultState = {
    list: [],
    isPending: false,
    // страна, для которой загружен список (см. fetchDictionaryIfNeeded)
    countries: null,
  };

  return (state = defaultState, action) => {
    switch (action.type) {
      case actionTypes.SET_LIST:
        return {
          ...state,
          list: transform ? transform(action.payload) : action.payload,
          isPending: false,
        };
      case actionTypes.SET_IS_PENDING:
        return { ...state, isPending: action.payload };
      case actionTypes.SET_COUNTRIES:
        return { ...state, countries: action.payload };
      default:
        return state;
    }
  };
};

export const createCommonItemReducer = (actionTypes = {}, transform) => {
  const defaultState = {
    item: {},
    isPending: false,
  };

  return (state = defaultState, action) => {
    switch (action.type) {
      case actionTypes.SET_ITEM:
        return {
          ...state,
          item: transform ? transform(action.payload) : action.payload,
        };
      case actionTypes.SET_IS_PENDING:
        return { ...state, isPending: action.payload };
      default:
        return state;
    }
  };
};

export const saveData =
  (url, eventType, isPendingType, resetType) => async (dispatch) => {
    if (isPendingType) {
      dispatch(createAction(isPendingType)(true));
    }
    try {
      const r = await commonGet({ url, eventType });
      const data = r?.data;
      if (eventType && data) {
        dispatch(createAction(eventType)(data));
      }
      return data;
    } catch (e) {
      if (resetType) {
        dispatch(
          createAction(eventType)(resetType === RESET_TYPES.LIST ? [] : {})
        );
      }
      return Promise.reject(e);
    } finally {
      if (isPendingType && !axiosEvents.get(eventType)) {
        dispatch(createAction(isPendingType)(false));
      }
    }
  };

// Реестры (семена, СЗР) сервер отдаёт с фильтром по стране учётки, поэтому
// запрашиваем их всегда с кодом страны и кэшируем вместе с ним: пока страна та
// же — отдаём кэш, сменилась (например, зашли под белорусской учёткой) —
// перезапрашиваем список. Одна точка входа для всех экранов, включая сервисы
// Байера, чтобы никто не заполнял общий кэш списком без фильтра по стране.
export const fetchDictionaryIfNeeded =
  ({ constants, getDictionary, selectDictionary }) =>
  (params) =>
  async (dispatch, getState) => {
    const state = getState();
    const countries =
      getAuthUserCountry(
        state.auth.currentCustomer,
        state.auth.currentAdvisor
      ) || null;
    const { list, countries: loadedCountries } = selectDictionary(state);

    if (list.length > 0 && loadedCountries === countries) {
      return Promise.resolve();
    }

    // Screens mounted together (the field page and its works) ask for the
    // same dictionary: one request instead of a second one that cancels the
    // first after the server has started it.
    const requestParams = countries ? { ...params, countries } : { ...params };
    const key = `${constants.SET_LIST} ${JSON.stringify(requestParams)}`;
    return shareInFlight(dispatch, key, async () => {
      const data = await dispatch(getDictionary(requestParams));
      dispatch(createAction(constants.SET_COUNTRIES)(countries));
      return data;
    });
  };

export const resetData = (eventType, resetType) => (dispatch) => {
  dispatch(createAction(eventType)(resetType === RESET_TYPES.LIST ? [] : {}));
};

export const fetchDictionariesItemIfNotExist =
  ({ itemId, itemStateKey, itemSubStateKey, itemConstants, getDictItem }) =>
  async (dispatch, getState) => {
    const itemData = itemSubStateKey
      ? getState()[itemStateKey][itemSubStateKey].item[itemId]
      : getState()[itemStateKey].item[itemId];
    if (!itemData) {
      try {
        dispatch(createAction(itemConstants.SET_IS_PENDING)(true));
        const item = await getDictItem(itemId);
        const previousState = itemSubStateKey
          ? getState()[itemStateKey][itemSubStateKey].item
          : getState()[itemStateKey].item;
        const result = {
          ...previousState,
          [itemId]: item.data,
        };
        dispatch(createAction(itemConstants.SET_ITEM)(result));
      } finally {
        dispatch(createAction(itemConstants.SET_IS_PENDING)(false));
      }
    }
  };
